




























































import Vue from "vue";

export default Vue.extend({
  name: "ProductionWork",
  data() {
    return {
      games: [
        {
          name: "Candy Match - Dream Factory",
          url: "https://play.google.com/store/apps/details?id=com.SparksGames.JumWorldMatchPuzzleGame",
          icon:
            "https://lh3.googleusercontent.com/RSrUO9c6hkab_R6Y2ji55E8xaPFTUSNPDGhfs4fkJ6vT4zTxRRCgr9v-5PJzzcm2pRK6TQ6mH3jAtOii5A5mQP4bY5ffmL5jd9XO%3Drw",
        },
        {
          name: "Block Escape 3D",
          url: "https://play.google.com/store/apps/details?id=com.sparksgames.blockesacape3d",
          icon:
            "https://lh3.googleusercontent.com/QoxgztUCGcxzSNbu1-c_FCaHFXATm8SqXA47_0DgtBK84VQZ8ds4jKHbyXZPOYLhMttKcbA2X514f9iWM3rFmZYI3U0TDRHrpp73HQ%3Drw",
        },
        {
          name: "Bus Rush - Puzzle Game",
          url: "https://play.google.com/store/apps/details?id=com.sparkgames.rushbustation",
          icon:
            "https://play-lh.googleusercontent.com/cwpjHa-nRo0zu7gVafGh3vOIV7DqMb0mMbZW6hLZckzhA7wtTB9CUl7LtxvXZatQy4XjZZsMokd5VztFOS__BQ%3Dw240-h480",
        },
      ],
    };
  },
});
